/**
 * Created by andrey on 01.12.2025
 */

const ConflictWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        const styles = cleverapps.styles.ConflictWindow;

        cleverapps.metrics.logEvent(cleverapps.EVENTS.SYSTEM.SYNC_CONFLICT_WINDOW);

        this.localSnapshot = options.localSnapshot;
        this.remoteSnapshot = options.remoteSnapshot;
        this.callback = options.callback || function () {};

        this._super({
            content: this.createContent(),
            name: "conflictwindow",
            title: Messages.get("ConflictWindow.Title"),
            button: {
                width: styles.button.width,
                text: Messages.get("ConflictWindow.UpdateNow")
            },
            closeButton: false
        });

        this.setLocalZOrder(Transition.ZORDER + 1);
        this._setGlobalZOrder(true);
    },

    getPerson: function () {
        return "hero";
    },

    createContent: function () {
        const styles = cleverapps.styles.ConflictWindow;

        const text = this.text = cleverapps.UI.generateOnlyText(Messages.get("ConflictWindow.YouHaveSavedGame"), cleverapps.styles.FONTS.CONFLICT_WINDOW_TEXT);
        text.setDimensions(styles.textWidth, 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const localHeader = ConflictWindow.getHeader(this.localSnapshot);
        const remoteHeader = ConflictWindow.getHeader(this.remoteSnapshot);

        const localBetters = ConflictWindow.getBetters(localHeader, remoteHeader);
        const remoteBetters = ConflictWindow.getBetters(remoteHeader, localHeader);

        const localView = new ConflictSnapshotView(localHeader, { local: true, betters: localBetters });
        const remoteView = new ConflictSnapshotView(remoteHeader, { remote: true, betters: remoteBetters });

        cc.Base.PerformRecursive(localView, (node) => {
            cleverapps.UI.convertToGrayScale(node);
        });

        const snapshots = new cleverapps.Layout([localView, remoteView], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.snapshots.margin,
            padding: styles.snapshots.padding
        });

        return new cleverapps.Layout([snapshots, text], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    onClose: function () {
        if (cleverapps.forces.isRunningForce()) {
            cleverapps.forces.closeRunningForce();
        }

        this.callback();
    },

    listBundles: function () {
        return ["conflict_window"];
    }
});

ConflictWindow.getHeader = function (snapshot) {
    const header = {};

    const users = snapshot.users || {};
    const meta = snapshot.metha || {};
    const games = snapshot.games || {};

    header.level = (users.episode || 0) * 15 + (users.level || 0) + (users.progress || 0) + 1;
    if (cleverapps.isKnockoutGame()) {
        header.level = (meta.knockoutLevel || 0) + 1;
    }

    header.visited = users.visited;

    if (["merge", "merge2", "match3"].includes(cleverapps.config.type)) {
        header.exp = users.exp;
    }

    if (["merge"].includes(cleverapps.config.type)) {
        header.wands = games.wands;
        header.soft = users.soft;
    }

    header.hard = users.gold;

    for (const key in header) {
        if (header[key] === undefined) {
            delete header[key];
        }
    }

    return header;
};

ConflictWindow.getBetters = function (snapshot, otherSnapshot) {
    return ["level", "exp", "hard", "soft", "wands"].filter((key) => (snapshot[key] || 0) > (otherSnapshot[key] || 0));
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CONFLICT_WINDOW_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.ConflictWindow = {
    margin: 30,
    textWidth: 900,

    snapshots: {
        margin: 100,
        padding: { x: 50, top: 30 }
    },

    button: {
        width: 400
    }
};